module.exports = __webpack_public_path__ + "img/game_main_pc_247_off.72de9ce4.png";